export interface EnvironmentVariables {
  API_URI: string;
  PHONE_VERIFICATION_SECONDS: number;
  MELI_GENERATE_TOKEN_URL: string;
  MERCADO_PAGO_GENERATE_TOKEN_URL: string;
  MENU_FACIL_URL: string;
  PRA_VENDAS_STORE_DOMAIN: string;
  VIA_CEP_API_URL: string;
  GEO_PRA_FRETES_API_URL: string;
  RS_SOLUTIONS_SITE_URL: string;
  PRA_FRETES_CORREIOS_API_URI: string;
  GEOLOCATION_API_URL: string;
  KDS_FACIL_URL: string;
  ADMIN_API_URL: string;
  PRA_FRETES_API_URL: string;
  AMAZON_GENERATE_AUTHORIZATION_CODE_URL: string;
  PRA_CHAMADOS_PANEL_DOMAIN: string;
}

export const env: EnvironmentVariables = {
  API_URI: process.env.API_URI ?? '',
  PHONE_VERIFICATION_SECONDS: Number(process.env.PHONE_VERIFICATION_SECONDS),
  MELI_GENERATE_TOKEN_URL: process.env.MELI_GENERATE_TOKEN_URL ?? '',
  MERCADO_PAGO_GENERATE_TOKEN_URL:
    process.env.MERCADO_PAGO_GENERATE_TOKEN_URL ?? '',
  MENU_FACIL_URL: process.env.MENU_FACIL_URL ?? '',
  PRA_VENDAS_STORE_DOMAIN: process.env.PRA_VENDAS_STORE_DOMAIN ?? '',
  VIA_CEP_API_URL: process.env.VIA_CEP_API_URL ?? '',
  GEO_PRA_FRETES_API_URL: process.env.GEO_PRA_FRETES_API_URL ?? '',
  RS_SOLUTIONS_SITE_URL: process.env.RS_SOLUTIONS_SITE_URL ?? '',
  PRA_FRETES_CORREIOS_API_URI: process.env.PRA_FRETES_CORREIOS_API_URI ?? '',
  GEOLOCATION_API_URL: process.env.GEOLOCATION_API_URL ?? '',
  KDS_FACIL_URL: process.env.KDS_FACIL_URL ?? '',
  ADMIN_API_URL: process.env.ADMIN_API_URL ?? '',
  PRA_FRETES_API_URL: process.env.PRA_FRETES_API_URL ?? '',
  AMAZON_GENERATE_AUTHORIZATION_CODE_URL:
    process.env.AMAZON_GENERATE_AUTHORIZATION_CODE_URL ?? '',
  PRA_CHAMADOS_PANEL_DOMAIN: process.env.PRA_CHAMADOS_PANEL_DOMAIN ?? '',
};
